import { render, staticRenderFns } from "./OverviewMyTeam.vue?vue&type=template&id=185e1800&"
import script from "./OverviewMyTeam.vue?vue&type=script&lang=js&"
export * from "./OverviewMyTeam.vue?vue&type=script&lang=js&"
import style0 from "./OverviewMyTeam.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports